import {withdrawLogList} from 'api/withdrawLog';
import Cookies from 'js-cookie';

const withdrawLog = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        withdrawLogList({commit},params) {
            return new Promise((resolve, reject) => {
                var startTime = params.startTime;
                var endTime = params.endTime;
                var accountBegin = params.accountBegin;
                var accountEnd = params.accountEnd;
                var agent = params.agent;
                var productId = params.productId;
                var psize = params.psize;
                var currentPage = params.currentPage;
                withdrawLogList(startTime,endTime,accountBegin,accountEnd,agent,productId,psize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default withdrawLog;



// WEBPACK FOOTER //
// ./src/store/modules/withdrawLog.js